import { c as _c } from "react/compiler-runtime";
import { ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface';
import { SubscriptionId } from 'modules/payment/subscriptions/types/subscription-interface';
import { SETTINGS_SUBSCRIPTIONS_API } from 'modules/profile/manage-subscriptions/api/update-customer-fields-api';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
interface ManageCustomerFieldsProps {
  subscriptionId: SubscriptionId;
  isFetchAllowed: boolean;
}
export const useManageCustomerFields = t0 => {
  const $ = _c(8);
  const {
    subscriptionId,
    isFetchAllowed
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== subscriptionId || $[2] !== user) {
    t2 = () => user && `${SETTINGS_SUBSCRIPTIONS_API}/${subscriptionId}/customer/field-values`;
    $[1] = subscriptionId;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    mutate,
    isLoading
  } = useControlledSwr(t2, fetcher, undefined, isFetchAllowed);
  let t3;
  if ($[4] !== data || $[5] !== isLoading || $[6] !== mutate) {
    t3 = {
      data,
      mutate,
      isLoadingFields: isLoading
    };
    $[4] = data;
    $[5] = isLoading;
    $[6] = mutate;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};